import { useRef } from 'react';
import { ICompany, IReviews } from '@/types/api/companies';
import { User } from '@/types/api/users';

export const ReviewsDefault = (reviews: IReviews[]) => {
  return useRef<IReviews[]>(reviews).current;
};

export const totalAverageReviews = (reviewsDefault: IReviews[]) => {
  const totalEvaluations = reviewsDefault.reduce(
    (acc, evaluation) => acc + evaluation.rating,
    0
  );
  return totalEvaluations / reviewsDefault.length;
};

export const canEditCompanyInstitutionalPage = (
  company: ICompany,
  user: User
) => {
  const isSuperAdmin = !!user.memberships?.find(
    membership => membership.company.id === company.id
  )?.is_superadmin;

  const companyMembership = company.memberships.find(
    membership => membership.user?.id === user.id
  );

  const isConfiguration =
    companyMembership?.is_validated &&
    companyMembership.has_confirmed_configuration;

  return isSuperAdmin || isConfiguration;
};

export function formatHour(hour: string) {
  return hour.split(':').slice(0, 2).join(':');
}

export function formatCompanyAddress(company: ICompany) {
  let addressFormatted = '';
  if (company.street) {
    addressFormatted += `${company.street.toLocaleLowerCase()} `;
  }
  if (company.number) {
    addressFormatted += `, ${company.number.toLocaleLowerCase()} `;
  }
  if (company.city) {
    addressFormatted += `, ${company.city} `;
  }
  if (company.state) {
    addressFormatted += `- ${company.state}`;
  }

  return addressFormatted;
}

export const WEEKDAYS = {
  0: 'Domingo',
  1: 'Segunda-feira',
  2: 'Terça-feira',
  3: 'Quarta-feira',
  4: 'Quinta-feira',
  5: 'Sexta-feira',
  6: 'Sábado',
} as const;

export const AVAILABILITY_STATUS = {
  Open: 'open',
  Closed: 'closed',
};
